"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QrCodeDocument = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useQrCodeImage_1 = require("./useQrCodeImage");
const renderer_1 = require("@react-pdf/renderer");
const qrCodeHelpers_1 = require("./qrCodeHelpers");
const react_1 = require("react");
const ROW_COUNT = 4;
const PAGE_COUNT = ROW_COUNT * 5;
const logTime = () => {
    const date = new Date();
    return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()},${date.getMilliseconds()}`;
};
const QrCodeDocument = ({ qrCodes, onLoadChange }) => {
    const [qrImageList, setGrImageList] = (0, react_1.useState)([]);
    const loadQrCodeImages = async () => {
        onLoadChange(false);
        const qrDataList = await Promise.all(qrCodes.map(code => (0, qrCodeHelpers_1.getQrCodeImage)(code)));
        setGrImageList(qrDataList);
        onLoadChange(true);
    };
    (0, react_1.useEffect)(() => {
        (() => loadQrCodeImages())();
    }, []);
    const pages = qrImageList.reduce((obj, image, currentIndex) => {
        const iPage = Math.floor(currentIndex / PAGE_COUNT);
        if (iPage >= obj.length) {
            obj.push([]);
        }
        obj[iPage].push(image);
        return obj;
    }, []);
    return ((0, jsx_runtime_1.jsx)(renderer_1.Document, { children: pages.map((images, index) => ((0, jsx_runtime_1.jsx)(renderer_1.Page, { size: "A4", style: { padding: 30 }, children: (0, jsx_runtime_1.jsx)(renderer_1.View, { style: { flex: 1, gap: 0, flexDirection: 'row', flexWrap: 'wrap', }, wrap: true, children: images.map((qrImage, index) => ((0, jsx_runtime_1.jsx)(renderer_1.View, { style: { alignItems: 'center', width: '25%', border: 1, borderStyle: 'dotted', borderColor: '#cccccc', padding: 2 }, children: (0, jsx_runtime_1.jsx)(renderer_1.View, { children: (0, jsx_runtime_1.jsx)(DocQrImage, { ...qrImage }) }) }, index))) }) }, index))) }));
};
exports.QrCodeDocument = QrCodeDocument;
const BASE_QR_CODE_WIDTH = 115;
const DocQrImage = ({ imageUrl, width, height }) => {
    return (0, jsx_runtime_1.jsx)(renderer_1.Image, { src: imageUrl, style: { height: BASE_QR_CODE_WIDTH / width * height, width: BASE_QR_CODE_WIDTH } });
};
const QrCodeDocImage = ({ value, label }) => {
    const { imageUrl, width, height } = (0, useQrCodeImage_1.useQrCodeImage)({ value, label: label });
    console.log("value, label", value, label, imageUrl);
    if (imageUrl && imageUrl !== "") {
        return (0, jsx_runtime_1.jsx)(renderer_1.Image, { src: imageUrl, style: { height: 100 / width * height, width: 100 } });
    }
    return null;
    //return <Image src={"https://react-pdf.org/images/logo.png"}/>;
};
